import React from "react";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import Semibreve from "../assets/semibreve.jsx";
import Minim from "../assets/minim.jsx";
import Crotchet from "../assets/crotchet.jsx";
import Quaver from "../assets/quaver.jsx";
import SemiQuaver from "../assets/semiquaver.jsx";
import update from 'immutability-helper';

/**
 * UpdateNoteTiming component.
 *
 * @param {Object} props - The component props.
 * @param {number} props.index - The index of the note.
 * @param {Object} props.drawing - The drawing object.
 * @param {function} props.handleEditFretboard - The function to handle editing the fretboard.
 * @returns {JSX.Element} The UpdateNoteTiming component.
 */
const UpdateNoteTiming = ({ index, drawing, handleEditFretboard }) => {

    function handleToggleTimingChange(event, value) {
        //update the timing within the drawing and then call updateDrawing
        const updatedDrawing = update(drawing, {
            timing: { $set: value }
        });
        handleEditFretboard(index, updatedDrawing);
    }

    const toggleButtonStyle = {
        borderRadius: 0,
        width: '32px',
        height: '32px',
        padding: 0,
        margin: 0
    }

    return (
        <ToggleButtonGroup
            value={drawing.timing}
            exclusive
            onChange={handleToggleTimingChange}
            aria-label="Timing"
            sx={{ alignItems: "center" }}
        >
            <ToggleButton value={.25} sx={toggleButtonStyle}>
                <Semibreve />
            </ToggleButton>
            <ToggleButton value={.5} sx={toggleButtonStyle}>
                <Minim />
            </ToggleButton>
            <ToggleButton value={1} sx={toggleButtonStyle}>
                <Crotchet />
            </ToggleButton>
            <ToggleButton value={2} sx={toggleButtonStyle}>
                <Quaver />
            </ToggleButton>

            <ToggleButton value={4} sx={toggleButtonStyle}>
                <SemiQuaver />
            </ToggleButton>
        </ToggleButtonGroup>
    );
};

export default UpdateNoteTiming;
